import React, { useEffect, useState } from "react";
import { deleteIcon, eyeIcon, uploadIcon } from "../svgs";
import api from "../../../api/api";
import { Backdrop, CircularProgress } from "@mui/material";
import ToastMessage from "../../../utils/mui/righttoptoast";
import UploadDocument from "../../patientcharts/tabs/Document/modals/uploadDocument";

export default function Document({ onUpload, activeTab, data, onView, onDelete }) {
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState("error");
  const [files, setFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const practiseid = window.getPracticeId();
const [isuploadmodal,setIsUploadModal]=useState(false)
   const handleView = (row) => {
    if (row.link) {
      window.open(row.link, "_blank", "noopener,noreferrer");
    } else {
      setToastMessage("No link available for viewing");
      setToastSeverity("info");
      setOpenToast(true);
    }
  };
  const handleDelete = (row) => {
  deletedoc(row.id)
  };

  const fetchDocs = async () => {
    setIsLoading(true);
    try {
      const response = await api.get(
        `/v1/${practiseid}/pcard/${data?.patientid}/getDocShare`,
        {
          imgbasepath: '',
          notes: '',
          tags: ''
        }
      );
      if (response.status === 200) {
         setFiles([...response.data].reverse());
      } else {
        setFiles([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
const deletedoc=async(id)=>{
  try {
    setIsLoading(true)
    const response=await api.delete(`/v1/${practiseid}/pcard/deleteDocShare`,{data:{
      doc_id:id}
    })
    if(response.status==200){
  setToastMessage('Document Deleted successfully');
        setToastSeverity('success');
        setOpenToast(true);
        fetchDocs();
    }else{
  setToastMessage(response.message||'Something went wrong');
        setToastSeverity('info');
        setOpenToast(true);
        
    }
  } catch (error) {
      setToastMessage('Something went wrong');
        setToastSeverity('error');
        setOpenToast(true);
    console.log(error)
  }finally{
    setIsLoading(false)
  }
}
  // const handlePdfUpload = async (e) => {
  //   const file = e.target.files[0];
  //   if (!file || file.type !== 'application/pdf') {
  //     setToastMessage('Only PDF files are allowed');
  //     setToastSeverity('error');
  //     setOpenToast(true);
  //     return;
  //   }

  //   setIsLoading(true);

  //   const formData = new FormData();
  //   formData.append('attachment', file);

  //   try {
  //     const response = await api.post(
  //       `/v1/${practiseid}/pcard/${data?.patientid}/dshare`,
  //       formData,
  //       { headers: { 'Content-Type': 'multipart/form-data' } }
  //     );

  //     if (response.status === 200 || response.status === 201) {
  //       setToastMessage('PDF uploaded successfully');
  //       setToastSeverity('success');
  //       setOpenToast(true);
  //       fetchDocs();
  //     } else {
  //       throw new Error('Upload failed');
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     setToastMessage('PDF upload failed');
  //     setToastSeverity('error');
  //     setOpenToast(true);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handlePdfUpload = async (files) => {
  if (!files || !files.length) return;

  setIsLoading(true);

  try {
    for (const file of files) {
      // if (file.type !== "application/pdf") {
      //   setToastMessage("Only PDF files are allowed");
      //   setToastSeverity("error");
      //   setOpenToast(true);
      //   continue; // skip non-pdf
      // }

      const formData = new FormData();
      formData.append("attachment", file);

      const response = await api.post(
        `/v1/${practiseid}/pcard/${data?.patientid}/dshare`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (!(response.status === 200 || response.status === 201)) {
        throw new Error("Upload failed");
      }
    }

setToastMessage(
  files.length > 1
    ? "Documents uploaded successfully"
    : "Document uploaded successfully"
);
    setToastSeverity("success");
    setOpenToast(true);
    fetchDocs();
  } catch (error) {
    console.error(error);
    setToastMessage("PDF upload failed");
    setToastSeverity("error");
    setOpenToast(true);
  } finally {
    setIsLoading(false);
  }
};
  useEffect(() => {
    if (activeTab === 'document') {
      fetchDocs();
    }
  }, [activeTab]);

  return (
    <div>
      {/* Top bar with Upload */}
      <div className="flex items-center justify-end px-4 sm:px-6 py-3">
       

        {/* PDF Upload Button */}
        {/* <label className="inline-flex items-center gap-2 px-4 py-2 rounded-lg font-inter font-normal text-[14px] bg-[#DCFCE7] text-[#166534] border-[1px] border-[#86EFAC] cursor-pointer">
          {uploadIcon}
          <span className="text-sm font-normal font-inter">Upload PDF</span>
          <input
            type="file"
            accept="application/pdf"
            onChange={handlePdfUpload}
            className="hidden"
          />
        </label> */}
          <label onClick={()=>{setIsUploadModal(true)}} className="inline-flex items-center gap-2 px-4 py-2 rounded-lg font-inter font-normal text-[14px] bg-[#DCFCE7] text-[#166534] border-[1px] border-[#86EFAC] cursor-pointer">
          {uploadIcon}
          <span className="text-sm font-normal font-inter">Upload PDF</span>
         
        </label>
      </div>

      {/* Table */}
      <div className="px-3 sm:px-4 pb-4">
        <div className="overflow-x-auto">
          <div className="align-middle inline-block min-w-full border border-gray-200 rounded-sm">
            <table className="min-w-full table-fixed">
              <colgroup>
                <col className="w-[64%]" />
                <col className="w-[12%]" />
                <col className="w-[12%]" />
                <col className="w-[12%]" />
              </colgroup>

              <thead>
                <tr>
                  <th className="text-left text-sm font-inter font-medium text-[#6B7280] bg-[#F9FAFB] px-4 py-3 rounded-tl-xl border-b border-[#E5E7EB]">Link</th>
                  <th className="text-left text-sm font-inter font-medium text-[#6B7280] bg-[#F9FAFB] px-4 py-3 rounded-tl-xl border-b border-[#E5E7EB]">Download</th>
                  <th className="text-left text-sm font-inter font-medium text-[#6B7280] bg-[#F9FAFB] px-4 py-3 rounded-tl-xl border-b border-[#E5E7EB]">Status</th>
                  <th className="text-left text-sm font-inter font-medium text-[#6B7280] bg-[#F9FAFB] px-4 py-3 rounded-tl-xl border-b border-[#E5E7EB]">Actions</th>
                </tr>
              </thead>

              <tbody>
                {files.length === 0 ? (
                  <tr>
                    <td colSpan={4} className="px-4 py-8 text-center">
                      <span className="inline-block px-5 py-2 rounded-lg border border-blue-600 bg-blue-50 text-blue-700 text-sm">
                        No Data Found
                      </span>
                    </td>
                  </tr>
                ) : (
                  files.map((row, idx) => (
                    <tr key={row.id ?? idx} className="border-b last:border-b-0">
                      <td className="align-top text-left text-xs px-4 py-4 font-inter text-[#111827]">
                        {row.link ? (
                          <a href={row.link} target="_blank" rel="noopener noreferrer" className="text-[#111827] hover:text-[#111827] hover:underline block truncate" title={row.link}>
                            {row.link}
                          </a>
                        ) : "-"}
                      </td>

                      <td className="align-top text-xs px-4 py-4 font-inter text-left text-[#111827] whitespace-nowrap">
                        {row.download === 'Y' ? 'Yes' : row.download === 'N' ? 'No' : '-'}
                      </td>

                      <td className="align-top text-xs px-4 py-4 font-inter text-left text-[#111827] whitespace-nowrap">
                        {row.status ? (row.status === 'A' ? 'Active' : 'InActive') : '-'}
                      </td>

                      <td className="align-top px-4 py-3 whitespace-nowrap">
                        <div className="flex items-center gap-2">
                          <button
                            onClick={() => handleView(row)}
                            className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-[#DCFCE7] text-[#15803D] text-sm font-inter"
                            title="View"
                          >
                            {eyeIcon}
                            <span>View</span>
                          </button>
                          <button
                            onClick={() => handleDelete(row)}
                            className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-[#FEE2E2] text-[#B91C1C] text-sm font-inter"
                            title="Delete"
                          >
                            {deleteIcon}
                            <span>Delete</span>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
   <UploadDocument
              data={data}
              setsubview={(x)=>{}}
  open={isuploadmodal}
  onClose={() => setIsUploadModal(false)}
    onUploadComplete={handlePdfUpload}
  
/>

      <ToastMessage
        message={toastMessage}
        severity={toastSeverity}
        open={openToast}
        handleClose={() => setOpenToast(false)}
      />

      <Backdrop
        sx={{
          color: '#fff',
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
